import axios from 'axios';

export class LoginRepository{

    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = axios.create({
            baseURL: `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/login`,
            timeout: 1000 * 60,
        });
        this.httpService = instance;
    }

    async login(email: string, password: string, opt?: string): Promise<LoginAPIResponse> {
        let data = new FormData()
        data.append('grant_type', 'password')
        data.append('client_id', `${process.env.REACT_APP_CLIENT_ID}`)
        data.append('scope', 'timekeeper schedule employee auth mdm_psc custom_reports')
        data.append('username', email)
        data.append('password', password)
        if (opt) {
            data.append('opt', opt)
        }

        const response = await this.httpService.post<LoginAPIResponse, FormData>('', {data});
        //console.log(response);
        return response;
    }
}